module.exports = __webpack_public_path__ + "img/community.622ee456.svg";